module.exports = __webpack_public_path__ + "img/dots-left-new.119993e8.png";